import { Grid, InputAdornment, Paper } from '@mui/material';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import UCheckbox from '../../utils/UCheckbox';
import UTextField2 from '../../utils/UTextField2';

export default function RecordComponent() {
  const { getValues } = useFormContext();
  const [showOptions, setShowOptions] = useState(getValues('record.enabled'));

  return (
    <Grid item xs={12}>
      <Paper style={{ backgroundColor: '#ffe8e8', padding: '16px 10px' }}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <h1 style={{ fontSize: '14px', margin: 0 }}>Recording</h1>
            <UCheckbox
              name="record.enabled"
              color="secondary"
              label="Enabled"
              defaultValue={false}
              onChange={(evt: any) => {
                setShowOptions(evt.target.checked);
              }}
            />
          </Grid>
          {showOptions && (
            <>
              <Grid item xs={4}>
                <UTextField2
                  name="record.storage"
                  options={{
                    valueAsNumber: true,
                    required: 'Storage is required',
                    min: { value: 0, message: 'Negative not allowed' },
                    max: { value: 1000, message: 'Should be lower than 1000' },
                  }}
                  fullWidth
                  label="Storage"
                  endAdornment={<InputAdornment position="end">Gb</InputAdornment>}
                  shrink={true}
                  type="number"
                  defaultValue="10"
                  required={true}
                />
              </Grid>
              <Grid item xs={4}>
                <UTextField2
                  name="record.time"
                  options={{
                    valueAsNumber: true,
                    required: 'Storage is required',
                    min: { value: 0, message: 'Negative not allowed' },
                    max: { value: 360, message: 'Should be lower than 360' },
                  }}
                  fullWidth
                  label="Storage"
                  endAdornment={<InputAdornment position="end">days</InputAdornment>}
                  shrink={true}
                  type="number"
                  defaultValue="0"
                  required={true}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Paper>
    </Grid>
  );
}
